var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 17 22",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9375 21.9992C15.3 21.9992 14.875 21.5592 14.875 20.8992V18.6992C14.875 16.8292 13.4937 15.3992 11.6875 15.3992H5.3125C3.50625 15.3992 2.125 16.8292 2.125 18.6992V20.8992C2.125 21.5592 1.7 21.9992 1.0625 21.9992C0.425 21.9992 0 21.5592 0 20.8992V18.6992C0 15.6192 2.3375 13.1992 5.3125 13.1992H11.6875C14.6625 13.1992 17 15.6192 17 18.6992V20.8992C17 21.5592 16.575 21.9992 15.9375 21.9992Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 11C5.525 11 3.1875 8.58 3.1875 5.5C3.1875 2.42 5.525 0 8.5 0C11.475 0 13.8125 2.42 13.8125 5.5C13.8125 8.58 11.475 11 8.5 11ZM8.5 2.2C6.69375 2.2 5.3125 3.63 5.3125 5.5C5.3125 7.37 6.69375 8.8 8.5 8.8C10.3063 8.8 11.6875 7.37 11.6875 5.5C11.6875 3.63 10.3063 2.2 8.5 2.2Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.2a40a29c2ee9767ddb54cb9eb735fa9e.svg";
export { ForwardRef as ReactComponent };